module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-modal modal fade noselect",
    attrs: {
      "id": "modalAjoutEditDossier"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Nom du " + _vm._s(_vm.modeDocument ? 'document' : 'dossier'))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.enregistrer($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nomDossierOuDocument),
      expression: "nomDossierOuDocument"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": " ",
      "maxlength": "100",
      "required": ""
    },
    domProps: {
      "value": (_vm.nomDossierOuDocument)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nomDossierOuDocument = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Nom")])])])]), _vm._v(" "), (_vm.modeDocument) ? _c('div', {
    staticClass: "tw-flex tw-mt-3"
  }, [_c('div', {
    staticClass: "tw-grow"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nomFichierLocal),
      expression: "nomFichierLocal"
    }],
    staticClass: "input tw-placeholder-gray-400",
    attrs: {
      "type": "text",
      "placeholder": ".csv, .pdf, .docx, .doc, .dsn, .xlsx, .xml, .png, .jpeg",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.nomFichierLocal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nomFichierLocal = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label tw-text-[#119bd2] tw-text-[0.8em] tw-top-0 tw-left-[5px] tw-h-[18px] tw-leading-[18px] tw-bg-transparent tw-w-[calc(100% - 20px)]"
  }, [_vm._v("Fichier local")])])]), _vm._v(" "), _c('div', {
    staticClass: "tw-ml-2"
  }, [_c('label', {
    staticClass: "inp-button blue mt-1"
  }, [_vm._v("\n                                Parcourir\n                                "), _c('input', {
    attrs: {
      "type": "file",
      "hidden": ""
    },
    on: {
      "change": function($event) {
        _vm.changeFile($event)
      }
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer tw-mt-6"
  }, [_c('div', {
    staticClass: "area-action"
  }, [_c('button', {
    staticClass: "inp-button-modal valid",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoading
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Valider")])]), _vm._v(" "), _c('button', {
    staticClass: "inp-button-modal cancel ml-1",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.annuler()
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Annuler")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "title": "Fermer"
    }
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6cffe48"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ged/ajoutEditDossier/modalAjoutEditDossier.vue.html
// module id = CDrx
// module chunks = 2